<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center class="rm-list-container pa-6">
      <v-flex xs12>
        <!-- ══ FILTERS CONTAINER ══ -->
        <div class="filter-card mb-6">
          <v-row align="center" class="ma-0">
            <v-col cols="12" sm="4" md="3" class="py-2 px-3">
              <span class="filter-label">District</span>
              <v-select
                outlined
                hide-details
                placeholder="All Districts"
                dense
                :items="districts"
                v-model="districtFilter"
                color="#14532D"
                class="custom-select"
              />
            </v-col>

            <v-col cols="12" sm="4" md="4" class="py-2 px-3">
              <span class="filter-label">Search Keyword</span>
              <v-text-field
                outlined
                hide-details
                placeholder="Search Name/Phone/Code"
                dense
                v-model="keyword"
                clearable
                color="#14532D"
                class="custom-input"
              />
            </v-col>

            <v-col cols="12" sm="4" md="5" class="py-2 px-3 d-flex align-end justify-sm-end">
              <v-btn
                v-if="selectedItems.length > 0"
                color="#D97706"
                dark
                class="add-btn mt-5 mr-3"
                @click="bulkRevokeDialog = true"
                depressed
              >
                <v-icon left size="16">mdi-swap-horizontal</v-icon>
                Bulk Revoke ({{ selectedItems.length }})
              </v-btn>
              <v-btn
                color="#14532D"
                class="add-btn mt-5"
                @click="openAddDialog()"
                depressed
              >
                <v-icon left size="16">mdi-plus</v-icon>
                Add External Ban
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- ══ TABLE CONTAINER ══ -->
        <v-layout wrap justify-start pt-2 v-if="userlist && userlist.length > 0">
          <v-flex xs12>
            <v-card class="custom-table-card elevation-0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 50px;">
                        <v-checkbox
                          v-model="selectAll"
                          color="#14532D"
                          hide-details
                          class="ma-0 pa-0"
                          @change="toggleSelectAll"
                        ></v-checkbox>
                      </th>
                      <th class="text-left">Rescuer Code</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">District</th>
                      <th class="text-left">Reason</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in userlist"
                      :key="index"
                      class="clickable-row"
                      @click="openEditDialog(item)"
                    >
                      <td @click.stop class="text-center">
                        <v-checkbox
                          v-model="selectedItems"
                          :value="item._id"
                          color="#14532D"
                          hide-details
                          class="ma-0 pa-0"
                        ></v-checkbox>
                      </td>
                      <td class="font-weight-medium">{{ item.rescuerCode || '-' }}</td>
                      <td class="font-weight-bold" style="color: #1E293B;">{{ item.name || '-' }}</td>
                      <td>{{ item.phone || '-' }}</td>
                      <td>{{ item.email || '-' }}</td>
                      <td>
                        <v-chip small color="rgba(20,83,45,0.08)" text-color="#14532D" class="font-weight-medium">
                          {{ item.district || '-' }}
                        </v-chip>
                      </td>
                      <td>{{ item.banreason || '-' }}</td>
                      <td class="text-center" @click.stop>
                        <div class="d-flex align-center justify-center action-group">
                          <!-- Edit Details -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <button
                                class="action-btn action-btn--edit"
                                v-bind="attrs"
                                v-on="on"
                                @click="openEditDialog(item)"
                              >
                                <v-icon size="16">mdi-pencil</v-icon>
                              </button>
                            </template>
                            <span>Edit Rescuer</span>
                          </v-tooltip>

                          <!-- Revoke Ban / Unban -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <button
                                class="action-btn action-btn--revoke"
                                v-bind="attrs"
                                v-on="on"
                                @click="openUnbanDialog(item._id)"
                              >
                                <v-icon size="16">mdi-swap-horizontal</v-icon>
                              </button>
                            </template>
                            <span>Revoke Ban</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Pagination -->
      <v-flex xs12 pb-4 v-if="userlist && userlist.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="Pagelength"
              :total-visible="7"
              circle
              color="#FF6907"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Empty State -->
      <v-flex xs12 v-else>
        <v-layout wrap justify-start pl-5>
          <v-flex xs12 class="text-left">
            <span class="heading">No Data Found!</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="bulkRevokeDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirm Bulk Revoke</v-card-title>
        <v-card-text>
          Are you sure you want to revoke the ban for {{ selectedItems.length }} selected external rescuers?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="bulkRevokeDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            color="#FF6907"
            light
            :ripple="false"
            depressed
            @click="bulkUnbanUser()"
            class="itemValue"
          >
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add/Edit Form Dialog -->
    <v-dialog v-model="formDialog" max-width="800" persistent>
      <v-card>
        <v-card-title class="heading">{{ isEditMode ? 'Edit Banned Rescuer' : 'Ban External Rescuer' }}</v-card-title>
        
        <v-card-text class="pt-4">
          <v-form ref="banForm" v-model="formValid">
            <v-layout wrap>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Name *" v-model="form.name" :rules="requiredRules" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Phone *" v-model="form.phone" :rules="requiredRules" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Email" v-model="form.email" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Rescuer Code" v-model="form.rescuerCode" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-select label="District *" :items="districts.filter(d => d !== 'All')" v-model="form.district" :rules="requiredRules" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Ban Reason *" v-model="form.banreason" :rules="requiredRules" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="ID Type" v-model="form.idType" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="ID Number" v-model="form.idNumber" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Aadhaar Number" v-model="form.adharnumber" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Education" v-model="form.education" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Employment" v-model="form.employment" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Blood Group" v-model="form.bloodGroup" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field label="Rescue Started At (YYYY)" v-model="form.rescueStartedAt" outlined dense color="#FF6907" />
              </v-flex>
              <v-flex xs12 px-2>
                <v-textarea label="Permanent Address" v-model="form.permanentAddress" outlined dense color="#FF6907" rows="2" />
              </v-flex>
              <v-flex xs12 px-2>
                <v-textarea label="Present Address" v-model="form.presentAddress" outlined dense color="#FF6907" rows="2" />
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            @click="formDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            color="#FF6907"
            depressed
            @click="saveExternalBan()"
            class="itemValue"
          >
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Unban Confirmation Dialog -->
    <v-dialog v-model="unbanDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>
          Are you sure you want to revoke the ban of this external rescuer?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            @click="unbanDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            color="#FF6907"
            depressed
            @click="unbanExternalUser()"
            class="itemValue"
          >
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    const pageKey = this.$route.name || 'defaultPage_external';
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      count: 20,
      keyword: "",
      districtFilter: "All",
      pageKey,
      currentPage: 1,
      Pagelength: 0,
      userlist: [],
      selectedItems: [],
      selectAll: false,
      bulkRevokeDialog: false,
      unbanDialog: false,
      formDialog: false,
      isEditMode: false,
      unbanId: null,
      formValid: false,
      requiredRules: [v => !!v || 'This field is required'],
      districts: [
        "All",
        "Palakkad",
        "Alappuzha",
        "Malappuram",
        "Kannur",
        "Wayanadu",
        "Kozhikode",
        "Thrissur",
        "Thiruvananthapuram",
        "Kottayam",
        "Idukki",
        "Ernakulam",
        "Kollam",
        "Pathanamthitta",
        "Kasaragod",
      ],
      form: {
        id: "",
        name: "",
        phone: "",
        email: "",
        rescuerCode: "",
        permanentAddress: "",
        presentAddress: "",
        district: "",
        idType: "",
        idNumber: "",
        banreason: "",
        adharnumber: "",
        education: "",
        employment: "",
        bloodGroup: "",
        rescueStartedAt: ""
      }
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    districtFilter() {
      this.getData();
      this.currentPage = 1;
    },
    keyword() {
      this.getData();
      this.currentPage = 1;
    }
  },
  methods: {
    toggleSelectAll(val) {
      if (val) {
        this.selectedItems = this.userlist.map(item => item._id);
      } else {
        this.selectedItems = [];
      }
    },
    // Fetch the list of banned external rescuers
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/rescuer/external/bannedlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          keyword: this.keyword,
          district: this.districtFilter === "All" ? "" : this.districtFilter
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            this.userlist = response.data.data;
            this.Pagelength = response.data.pages;
            this.selectedItems = [];
            this.selectAll = false;
          } else {
            this.userlist = [];
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error(err);
        });
    },

    // Dialog control triggers
    openAddDialog() {
      this.isEditMode = false;
      this.form = {
        id: "",
        name: "",
        phone: "",
        email: "",
        rescuerCode: "",
        permanentAddress: "",
        presentAddress: "",
        district: "",
        idType: "",
        idNumber: "",
        banreason: "",
        adharnumber: "",
        education: "",
        employment: "",
        bloodGroup: "",
        rescueStartedAt: ""
      };
      if (this.$refs.banForm) {
        this.$refs.banForm.resetValidation();
      }
      this.formDialog = true;
    },
    openEditDialog(item) {
      this.isEditMode = true;
      this.form = {
        id: item._id,
        name: item.name || "",
        phone: item.phone || "",
        email: item.email || "",
        rescuerCode: item.rescuerCode || "",
        permanentAddress: item.permanentAddress || "",
        presentAddress: item.presentAddress || "",
        district: item.district || "",
        idType: item.idType || "",
        idNumber: item.idNumber || "",
        banreason: item.banreason || "",
        adharnumber: item.adharnumber || "",
        education: item.education || "",
        employment: item.employment || "",
        bloodGroup: item.bloodGroup || "",
        rescueStartedAt: item.rescueStartedAt || ""
      };
      if (this.$refs.banForm) {
        this.$refs.banForm.resetValidation();
      }
      this.formDialog = true;
    },
    openUnbanDialog(id) {
      this.unbanId = id;
      this.unbanDialog = true;
    },

    // Save (Create or Edit) Handler
    saveExternalBan() {
      if (!this.$refs.banForm.validate()) {
        this.msg = "Please fill in all required fields.";
        this.showSnackBar = true;
        return;
      }
      
      this.appLoading = true;
      const isEdit = this.isEditMode;
      const url = isEdit ? "/rescuer/external/edit" : "/rescuer/external/ban";
      
      axios({
        method: "POST",
        url: url,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.form,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            this.msg = isEdit ? "Edited successfully." : "Banned successfully.";
            this.showSnackBar = true;
            this.formDialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error(err);
        });
    },

    // Unban Handler
    bulkUnbanUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/rescuer/external/bulkunban",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          ids: this.selectedItems,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            this.msg = "Revoked Successfully.";
            this.showSnackBar = true;
            this.bulkRevokeDialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.bulkRevokeDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error(err);
        });
    },
    unbanExternalUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/rescuer/external/unban",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.unbanId,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            this.msg = "Revoked Successfully.";
            this.showSnackBar = true;
            this.unbanDialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.unbanDialog = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
/* ── Filter Card ── */
.filter-card {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  padding: 12px 6px;
}
.filter-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748B;
  margin-bottom: 6px;
  padding-left: 2px;
}

/* ── Custom Inputs ── */
.custom-select ::v-deep .v-input__control > .v-input__slot,
.custom-input ::v-deep .v-input__control > .v-input__slot {
  background: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}
.custom-select ::v-deep .v-input__control > .v-input__slot:hover,
.custom-input ::v-deep .v-input__control > .v-input__slot:hover {
  border-color: #CBD5E1 !important;
  background: #F1F5F9 !important;
}

/* ── Add Button ── */
.add-btn {
  background-color: #14532D !important;
  color: #FFFFFF !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  border-radius: 8px !important;
  height: 40px !important;
  box-shadow: 0 4px 12px rgba(20, 83, 45, 0.18) !important;
  transition: all 0.2s ease !important;
}
.add-btn:hover {
  background-color: #166534 !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(20, 83, 45, 0.25) !important;
}

/* ── Table Card ── */
.custom-table-card {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.03) !important;
  background: #FFFFFF;
}

/* Table layout styling */
.custom-table-card ::v-deep table {
  border-collapse: collapse;
  width: 100%;
}
.custom-table-card ::v-deep thead {
  background-color: #F8FAFC;
}
.custom-table-card ::v-deep th {
  height: 48px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.06em !important;
  color: #64748B !important;
  text-transform: uppercase !important;
  border-bottom: 2px solid #F1F5F9 !important;
  padding: 0 16px !important;
}
.custom-table-card ::v-deep td {
  height: 58px !important;
  font-size: 13px !important;
  color: #334155 !important;
  border-bottom: 1px solid #F1F5F9 !important;
  padding: 0 16px !important;
}

/* ── Clickable Rows ── */
.clickable-row {
  cursor: pointer;
  transition: background-color 0.18s ease;
}
.clickable-row:hover {
  background-color: #F3F7F4 !important;
}
.clickable-row:active {
  background-color: #EBF2ED !important;
}
.text-muted {
  color: #94A3B8;
}

/* ── Action buttons ── */
.action-group {
  gap: 8px;
}
.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.action-btn:hover {
  transform: scale(1.08);
}
.action-btn--edit {
  background: rgba(20, 83, 45, 0.06);
  color: #16A34A !important;
}
.action-btn--edit:hover {
  background: rgba(20, 83, 45, 0.12);
  color: #14532D !important;
}
.action-btn--revoke {
  background: rgba(217, 119, 6, 0.06);
  color: #D97706 !important;
}
.action-btn--revoke:hover {
  background: rgba(217, 119, 6, 0.12);
  color: #B45309 !important;
}

/* ── Empty State ── */
.empty-state {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px dashed #E2E8F0;
}
</style>
